import { $getStorage } from "../../common/common"
import { $setStorage } from "../../common/common"
import { getNowTime } from "../../API/nowTime/getNowTime"
const time = getNowTime()

const receiving = {
  state: {
    localId: $getStorage("localId"),
    localTime: sessionStorage.getItem("localTime") || time,
  },
  mutations: {
    SET_localId(state, provider) {
      state.localId = provider
      // sessionStorage.setItem("localId", state.localId)
      $setStorage("localId", state.localId)
    },
    SET_localTime(state, provider) {
      state.localTime = provider
      sessionStorage.setItem("localTime", state.localTime)
    },
  },
}
export default receiving
